import * as Yup from "yup";

export const DirectBossSchema = Yup.object({
  bossId: Yup.number()
    .required("Debe seleccionar un jefe directo")
    .positive("Debe seleccionar un jefe directo"),
  employeeIds: Yup.array()
    .of(Yup.number())
    .min(1, "Debe seleccionar al menos un empleado")
    .required("Debe seleccionar al menos un empleado"),
  description: Yup.string()
    .max(500, "La descripción no puede exceder 500 caracteres")
    .optional(),
});
